/**
 * Token-classifier numbers — match `FUN_0046f330` in NCSEXPER. Useful for diagnostics.
 */
export const TOKEN_CLASS = {
    EOF: 6, // \0, \n, \r — end of expression
    NOT: 2, // '!'
    LPAREN: 9, // '('
    RPAREN: 10, // ')'
    COMBINATOR: 3, // '+' (AND) or ',' (OR)
    LITERAL: 1, // '0' or '1'
    ERROR: 0, // anything else
};
export class PredicateError extends Error {
    offset;
    constructor(message, offset) {
        super(message);
        this.offset = offset;
        this.name = 'PredicateError';
    }
}
//# sourceMappingURL=types.js.map